/** Strings owned by `src/features/users/` — WP-12's Users section (scoped
 * to the active company), `UserDetailPage`, `UserEditPage`, `AddPersonPage`
 * und `memberActions.tsx` (§ Bedrijfscontext, § Zichtbaarheid). */
export const users = {
  page: {
    title: 'Benutzer',
    noScope: 'Du hast keine Verwaltungsbefugnis, daher gibt es keine Mitgliederliste zu zeigen.',
    departmentListsTitle: 'Mitgliederlisten je Abteilung',
    leadCompany: 'Mitglieder von {{company}}.',
    membersOf: 'Mitglieder von {{company}}',
    companyMembersCardTitle: 'Mitglieder',
    addPerson: 'Person hinzufügen',
    empty: 'Keine Mitglieder.',
    name: 'Name',
    email: 'E-Mail',
    login: 'Login',
    source: 'Quelle',
    yes: 'ja',
    no: 'nein',
    invitePerson: 'Einladen',
    importCsv: 'CSV importieren',
    searchPlaceholder: 'Nach Name oder E-Mail suchen…',
    filterDepartment: 'Abteilung',
    allDepartments: 'Alle Abteilungen',
    filterLocation: 'Standort',
    allLocations: 'Alle Standorte',
    filterStatus: 'Status',
    allStatuses: 'Alle Status',
    employee: 'Mitarbeiter',
    department: 'Abteilung',
    location: 'Standort',
    lastSync: 'Letzte Synchronisierung',
    consent: 'Einwilligung',
    wearable: 'Wearable',
    pilot: 'Pilot',
    account: 'Konto',
    actions: 'Aktionen',
    accountActive: 'Aktiv',
    accountDeactivated: 'Deaktiviert',
    noLocation: 'Kein Standort',
    noDepartment: 'Keine Abteilung',
    activation: {
      label: 'Aktivierung',
      invited: 'Eingeladen',
      activated: 'Aktiviert',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      deactivated: 'Deaktiviert',
    },
    consentStatus: {
      pending: 'Ausstehend',
      confirmed: 'Bestätigt',
      declined: 'Widerrufen',
      none: 'Keine',
    },
  },
  detail: {
    thisPerson: 'diese Person',
    edit: 'Bearbeiten',
    name: 'Name',
    email: 'E-Mail',
    nickname: 'Spitzname',
    preferredLanguage: 'Bevorzugte Sprache',
    region: 'Region',
    login: 'Login',
    yes: 'ja',
    no: 'nein',
    gender: 'Geschlecht',
    birthdate: 'Geburtsdatum',
    height: 'Größe',
    weight: 'Gewicht',
    privateNote:
      'Geschlecht, Geburtsdatum, Größe und Gewicht sind privat für diese Person und Teil keiner fremden Ansicht auf sie.',
    actionsCardTitle: 'Aktionen',
    statsCardTitle: 'Statistiken',
  },
  edit: {
    title: 'Persönliche Angaben bearbeiten',
    lead: 'Name und E-Mail stammen aus dem Anmeldekonto und können hier nicht geändert werden.',
    cancel: 'Abbrechen',
    save: 'Speichern',
  },
  addPerson: {
    created: 'Person erstellt.',
    inviteSent: 'Eine Einladungs-E-Mail ist unterwegs.',
    alreadyHasLogin: 'Diese Person hat bereits ein Login.',
    noLoginYet: 'Noch kein Login — du kannst sie später aus der Mitgliederliste einladen.',
    done: 'Fertig',
    name: 'Name',
    email: 'E-Mail',
    emailHint: 'Optional — mit einer Adresse wird die Person zur Anmeldung eingeladen.',
    nickname: 'Spitzname',
    region: 'Region',
    conflict:
      'Es gibt bereits eine Person mit dieser E-Mail-Adresse{{reason}}. Füge diese bestehende Person der Scope hinzu, statt eine Dublette zu erstellen.',
    cancel: 'Abbrechen',
    create: 'Person erstellen',
    companyTitle: 'Person zum Unternehmen hinzufügen',
    departmentTitle: 'Person zur Abteilung hinzufügen',
    newPersonCardTitle: 'Neue Person',
    existingCardTitle: 'Bestehendes Unternehmensmitglied',
    existingPersonCardTitle: 'Bestehende Person',
    member: 'Mitglied',
    person: 'Person',
    choose: 'Wählen…',
    addToDepartment: 'Zur Abteilung hinzufügen',
    addToCompany: 'Zum Unternehmen hinzufügen',
    searchPeople: 'Personen suchen',
    searchPlaceholder: 'Name oder E-Mail',
    noEligible: 'Keine passende Person gefunden.',
    editionMismatch:
      'Diese Person hat eine andere Edition als das Unternehmen. Ändere zuerst die Edition der Person oder des Unternehmens und versuche es erneut.',
  },
  actions: {
    invite: 'Einladen',
    inviteAgain: 'Erneut einladen',
    changeEmail: 'E-Mail ändern',
    newEmail: 'Neue E-Mail-Adresse',
    save: 'Speichern',
    cancel: 'Abbrechen',
    remove: 'Entfernen',
    unlink: 'Verknüpfung aufheben',
    unlinkFromPilot: 'Vom Pilotprojekt trennen',
    erase: 'Löschen',
    changeLocation: 'Standort ändern',
    changeDepartment: 'Abteilung ändern',
    deactivate: 'Deaktivieren',
    activate: 'Aktivieren',
  },
  invite: {
    title: 'Person einladen',
    name: 'Name',
    email: 'E-Mail-Adresse',
    role: 'Rolle',
    roleMember: 'Mitarbeiter',
    roleAdmin: 'Unternehmensadmin',
    submit: 'Einladen',
    cancel: 'Abbrechen',
  },
  import: {
    title: 'CSV importieren',
    instructions:
      'Fügen Sie eine CSV mit den Spalten ein oder laden Sie sie hoch: Name, E-Mail, Abteilung, Standort.',
    csvLabel: 'CSV',
    placeholder: 'Jane Doe,jane@example.com,Sales,DC Rotterdam',
    uploadLabel: 'Oder eine Datei hochladen',
    submit: 'Importieren',
    cancel: 'Abbrechen',
    done: 'Fertig',
    summary: '{{imported}} importiert, {{failed}} fehlgeschlagen.',
    rowLabel: 'Zeile {{row}}',
    rowSuccess: 'Importiert',
    rowFailed: 'Fehlgeschlagen',
  },
} as const;
